export enum OfferType {
    'SAP' = 'SAP',
    'PTI' = 'PTI'
}
